let url = 'https://api.rawg.io/api';
let token = 'b56cdf0b027d4a389054e0dafa20a938';

export { url, token };